import { store } from "@store/index";
import {
  selectCurrentVersion,
  selectOsVersion,
  selectProductId,
} from "@utils/redux-utils/selectors/productSelectors";
import { getProductHardwareLabel } from "@utils/productUtils";
import type { HardwareModels } from "types/productTypes";

export type SupportDeviceContext = {
  productId: string;
  headsetModel: string;
  headsetAppVersion: string;
  headsetOsVersion: string;
};

export type HelpRequestSource = "help-form" | "chatbase";

export function buildSupportDeviceContext(): SupportDeviceContext | undefined {
  const state = store.getState();
  const productId = (selectProductId(state) ?? "").trim();
  if (!productId) {
    return undefined;
  }

  return {
    productId,
    headsetModel: getProductHardwareLabel(productId.split("-")[0] as HardwareModels) ?? "",
    headsetAppVersion: (selectCurrentVersion(state) ?? "").trim(),
    headsetOsVersion: (selectOsVersion(state) ?? "").trim(),
  };
}

export function resolveReplyToEmail(
  trimmedReplyEmail: string,
  prefillLoaded: boolean,
): string | undefined {
  if (trimmedReplyEmail) {
    return trimmedReplyEmail;
  }
  return prefillLoaded ? "" : undefined;
}
